var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"skeleton-main skeleton-o-media",class:_vm.customClass},[_c('span',{staticClass:"flex w-full"},[_c('span',{staticClass:"skeleton-box",style:(`width: ${_vm.size}`)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }